import React from 'react'
import sharebtn from '../Assets/sharebtn.PNG'
import urlfield from '../Assets/url.PNG'
import AddTile from './AddTile'

class AddNew extends React.Component {

  constructor() {
    super()
    this.state = {
      showHelp: false,
      addTile: false
    }
  }

  toggleHelp = () => {
    this.setState({ showHelp: !this.state.showHelp })
  }

  changeToCustomTile = () => {
    this.setState({ addTile: true })
  }

  changeToNewTimetable = () => {
    this.setState({ addTile: false })
  }

  render() {

      return (
        <div className="AddNew">
          <nav className="navbar navbar-expand-lg navbar-dark bg-primary">
            <span className="navbar-brand">{
              this.state.addTile
                ?
                (<div><button className="btn btn-link text-white small" onClick={this.changeToNewTimetable}>Add new timetable</button> / <strong>Add new tile</strong></div>)
                :
                (<div><strong>Add new timetable</strong> / <button className="btn btn-link text-white small" onClick={this.changeToCustomTile}>Add new tile</button></div>)
            }</span>
            <ul className="navbar-nav ml-auto">
              <li>
                <button className="btn btn-danger" onClick={this.props.close}><i class="fas fa-times"></i></button>
              </li>
            </ul>
          </nav>

          {this.state.addTile ? <AddTile changeBack={this.changeToNewTimetable} users={this.props.users} room={this.props.room} /> :
            <div className="text-center p-4 mx-auto">
              <div className="input-group p-2">
                <input type="text" className="form-control" placeholder="Name" value={this.props.nameField} onChange={this.props.onNameChange} />
              </div>
              <div className="input-group p-2">
                <input type="text" className="form-control" placeholder="NUSMods sharable url (eg. http://modsn.us/3B5NK)" value={this.props.urlField} onChange={this.props.onUrlChange} />
              </div>

              <div className="showHelp">
                <button className="btn btn-link btn-sm" onClick={this.toggleHelp}>Unsure of how to get the NUSMods shareable url?</button>

                {this.state.showHelp ? (
                  <h6 className="help">
                    Click on <img style={{ width: 72 }} src={sharebtn} alt="the share/sync button" />  at the bottom right of NUSMods <br />
                    Copy and paste the url in the url field above <br />
                    <img src={urlfield} style={{ width: '80%' }} alt="" />
                  </h6>
                ) : (null)}
              </div>

              <button className="btn btn-success" style={{ borderRadius: 50 }} onClick={this.props.submit}>Add</button>
            </div>
          }




        </div>
      )
    
  }
}

export default AddNew